/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type IssueDetail from '@jira/spa-apps__admin-pages-performance-metric-detail-issue/src/IssueDetail.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyIssueDetail: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof IssueDetail
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-system-performance-metric-detail", jiraSpaEntry: "async-system-performance-issue" */ '@jira/spa-apps__admin-pages-performance-metric-detail-issue/src/IssueDetail.tsx'
		),
	),
);

export const IssueMetricDetail = (): React.JSX.Element => (
	<LazyPage
		Page={LazyIssueDetail}
		pageId="system-performance-metric-detail-issue"
		shouldShowSpinner
	/>
);
